// extracted by mini-css-extract-plugin
export default {"video-section":"VibesPlayer_video-section__sDMxr","video-wrapper":"VibesPlayer_video-wrapper__XbiwY"};